import React from 'react'
import Line from '../Line'
/**
 * Display children in columns
 */
const Columns = props => <Line {...props} vertical={false} />

export default Columns
